export const getProfileIncomeLandingShortCutDetailsStyle = (theme) => ({
    fontSize: '8pt',
});
